const normalizeFilter = (filter: string[] = []) => [...filter].map((item) => item.toUpperCase()).sort()
const normalizeNumericFilter = (filter: number[] = []) => [...filter].sort((a, b) => a - b)

const queryKeys = {
	dashboard: {
		week: (params: { filterOutFrequencies?: string[]; weeksBack?: number } = {}) => ['dashboard', 'week', {
			filterOutFrequencies: normalizeFilter(params.filterOutFrequencies || []),
			weeksBack: params.weeksBack || 0
		}] as const,
		completedJobsByHour: (weeksBack: number = 0) => ['dashboard', 'completed-jobs-by-hour', weeksBack] as const,
		workTime: (weeksBack: number = 0) => ['dashboard', 'work-time', weeksBack] as const,
		ratings: () => ['dashboard', 'ratings'] as const
	},
	statistics: {
		finishesPerMonth: () => ['statistics', 'finishes-per-month'] as const,
		priceOffersSentPerMonth: () => ['statistics', 'price-offers-sent-per-month'] as const,
		successRatePerPerson: () => ['statistics', 'success-rate-per-person'] as const,
		jobsLifecyclePerMonth: (params: {
			organizationIds?: number[];
			monthsBack?: number;
		} = {}) => ['statistics', 'jobs-lifecycle-per-month', {
			organizationIds: normalizeNumericFilter(params.organizationIds || []),
			monthsBack: params.monthsBack || 12
		}] as const,
		sutazOdovzdavaniaNacas: (params: {
			organizationIds?: number[];
			userId?: number | null;
			month?: string | null;
		} = {}) => ['statistics', 'sutaz-odovzdavanie-nacas', {
			organizationIds: normalizeNumericFilter(params.organizationIds || []),
			userId: params.userId || null,
			month: params.month || null
		}] as const,
		priceOffersStatusPerMonth: (params: {
			startDate?: string;
			endDate?: string;
			employeeID?: number | null;
			status?: string[];
			organizationID?: number | null;
		} = {}) => ['statistics', 'price-offers-status-per-month', {
			startDate: params.startDate || null,
			endDate: params.endDate || null,
			employeeID: params.employeeID || null,
			organizationID: params.organizationID || null,
			status: normalizeFilter(params.status || [])
		}] as const
	},
	priceOffers: {
		list: (params: {
			page?: number;
			limit?: number;
			search?: string | null;
			orderBy?: string | null;
			orderDirection?: string | null;
			employeeID?: number | null;
			organizationID?: number | null;
			startDate?: string | null;
			endDate?: string | null;
			status?: string[];
			allAvailableOrganizations?: boolean;
			deleted?: boolean;
		} = {}) => ['priceOffers', 'list', {
			page: params.page || 1,
			limit: params.limit || 20,
			search: params.search || null,
			orderBy: params.orderBy || null,
			orderDirection: params.orderDirection || null,
			employeeID: params.employeeID || null,
			organizationID: params.organizationID || null,
			startDate: params.startDate || null,
			endDate: params.endDate || null,
			status: normalizeFilter(params.status || []),
			allAvailableOrganizations: params.allAvailableOrganizations || false,
			deleted: params.deleted || false
		}] as const
	},
	storeItemTransactions: {
		list: (params: {
			page?: number;
			limit?: number;
			search?: string | null;
			orderBy?: string | null;
			orderDirection?: string | null;
			amount?: number | null;
			type?: string | null;
			jobFromID?: number | null;
			jobToID?: number | null;
			userExecutorID?: number | null;
			storeItemID?: number | null;
			startDate?: string | null;
			endDate?: string | null;
		} = {}) => ['storeItemTransactions', 'list', {
			page: params.page || 1,
			limit: params.limit || 20,
			search: params.search || null,
			orderBy: params.orderBy || null,
			orderDirection: params.orderDirection || null,
			amount: params.amount ?? null,
			type: params.type || null,
			jobFromID: params.jobFromID || null,
			jobToID: params.jobToID || null,
			userExecutorID: params.userExecutorID || null,
			storeItemID: params.storeItemID || null,
			startDate: params.startDate || null,
			endDate: params.endDate || null
		}] as const,
		jobOptions: (search: string | null = null) => ['storeItemTransactions', 'job-options', search || null] as const,
		storeItemOptions: (search: string | null = null) => ['storeItemTransactions', 'store-item-options', search || null] as const,
		userOptions: (search: string | null = null) => ['storeItemTransactions', 'user-options', search || null] as const
	},
	ratings: {
		list: (params: {
			page?: number;
			limit?: number;
			search?: string | null;
			orderBy?: string | null;
			orderDirection?: string | null;
			users?: number[];
			ratings?: number[];
			startDate?: string | null;
			endDate?: string | null;
			showDeleted?: boolean;
		} = {}) => ['ratings', 'list', {
			page: params.page || 1,
			limit: params.limit || 20,
			search: params.search || null,
			orderBy: params.orderBy || null,
			orderDirection: params.orderDirection || null,
			users: normalizeNumericFilter(params.users || []),
			ratings: normalizeNumericFilter(params.ratings || []),
			startDate: params.startDate || null,
			endDate: params.endDate || null,
			showDeleted: params.showDeleted || false
		}] as const
	},
	superOrganization: {
		jobs: (params: {
			page?: number;
			limit?: number;
			search?: string | null;
			organizationIDs?: number[];
			users?: number[];
			priceOfferFirmHeaderIDs?: number[];
			withoutFirmHeader?: boolean;
			inflationPartAccepted?: boolean | null;
			orderBy?: string | null;
			orderDirection?: string | null;
		} = {}) => ['super-organization', 'jobs', {
			page: params.page || 1,
			limit: params.limit || 20,
			search: params.search || null,
			organizationIDs: normalizeNumericFilter(params.organizationIDs || []),
			users: normalizeNumericFilter(params.users || []),
			priceOfferFirmHeaderIDs: normalizeNumericFilter(params.priceOfferFirmHeaderIDs || []),
			withoutFirmHeader: params.withoutFirmHeader || false,
			inflationPartAccepted: params.inflationPartAccepted ?? null,
			orderBy: params.orderBy || null,
			orderDirection: params.orderDirection || null
		}] as const
	}
}

export default queryKeys
